import { Validators } from '@angular/forms';
import { OneClickPaymentDisabler } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-payment-enabler.provider';
import { OneClickProductDisabler } from '@ordersnproducts/modules/one-click-order/providers/builder/one-click-product-enabler.provider';
import { OneClickLoadProductUnits } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-units.command.service';
import { SALES_DOCUMENT_TYPE_ID } from '@ordersnproducts/modules/shared/constants/sales-document-type-id';
import { FieldProductSelectionConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-product-selection-config.interface';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldSelectConfig } from '../../../../../shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { FormSelectComponent } from '../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import {
  FieldClassesDeliveryBuilder,
  FieldClassesOwnFreightuilder,
} from '../../../../constants/builder-field-classes.enum';
import { OneClickBuilderPaymentsEffects } from '../../../../effects/one-click-payment-builder.effects';
import { OneClickDeliveryMethodProvider } from '../../../../providers/order/one-click-delivery-method.provider';
import { OneClickEditProvider } from '../../../../providers/order/one-click-edit.provider';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLoadProductPayments } from '../../../../services/commands/one-click-payments.command.service';
import { OneClickSyncJobsiteLoadProducts } from '../../../../services/commands/one-click-sync-jobsites.command.service';
import { OneClickSyncPayment } from '../../../../services/commands/one-click-sync-payment.command';
import { OneClickSyncProduct } from '../../../../services/commands/one-click-sync-product.command.service';
import { OneClickJobsiteLoaderService } from '../../../../services/loaders/one-click-jobsites.loader.service';
import { OneClickPaymentsLoaderService } from '../../../../services/loaders/one-click-payments.loader.service';
import { OneClickProductsLoaderService } from '../../../../services/loaders/one-click-products.loader.service';
import { OneClickBuilderField } from '../../../../util/constants/builder-fields';

export const jobsite: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: '',
    text: OneClickDeliveryMethodProvider.TextBuilder,
    label: 'views.one_click.delivery_method',
    containerClassNames: [FieldClassesDeliveryBuilder.DELIVERY_METHOD_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    name: '',
    type: FormGenericItemComponent,
    text: OneClickLocationProvider.TextBuilder,
    label: 'views.one_click.jobsite',
    containerClassNames: [FieldClassesDeliveryBuilder.LOCATION_READONLY],
    visible: OneClickEditProvider.VisibleEdit,
  } as FieldLabelConfig,
  {
    name: OneClickBuilderField.Jobsite,
    type: FormSelectComponent,
    label: 'views.one_click.jobsite',
    onChange: [OneClickSyncJobsiteLoadProducts],
    placeholder: 'views.one_click.select_jobsite',
    optionsLoader: OneClickJobsiteLoaderService,
    containerClassNames: [FieldClassesOwnFreightuilder.LOCATION],
    validation: [Validators.required],
    visible: OneClickEditProvider.VisibleCreate,
  } as FieldSelectConfig,
  {
    type: FormSelectComponent,
    label: 'views.one_click.product',
    name: OneClickBuilderField.Product,
    containerClassNames: ['col-md-6 mb-3 retail-control text-capitalize'],
    placeholder: 'views.one_click.select_product',
    onChange: [OneClickSyncProduct, OneClickLoadProductPayments, OneClickLoadProductUnits],
    loading: OneClickProductDisabler,
    optionsLoader: OneClickProductsLoaderService,
    validation: [Validators.required],
    dropdownSalesDocumentTypes: [SALES_DOCUMENT_TYPE_ID.TOP_PRODUCTS],
  } as FieldProductSelectionConfig,
  {
    type: FormSelectComponent,
    label: 'views.specifications.paymentTerms',
    name: OneClickBuilderField.Payment,
    containerClassNames: ['col-md-6 mb-3 retail-control text-capitalize'],
    placeholder: 'views.one_click.select_payment',
    onChange: [OneClickSyncPayment],
    dynamicEffects: [OneClickBuilderPaymentsEffects],
    optionsLoader: OneClickPaymentsLoaderService,
    validation: [Validators.required],
    loading: OneClickPaymentDisabler,
  } as FieldSelectConfig,
];
